import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { courseAPI } from '../api';
import { FiClock, FiBook, FiUsers, FiFilter, FiChevronDown, FiChevronUp, FiHome, FiHeart, FiArrowLeft } from 'react-icons/fi';
import { getMediaUrl } from '../utils/config';

// 格式化时间为 MM:SS 格式
const formatTime = (seconds) => {
  // 确保输入是数字
  const secs = typeof seconds === 'number' ? seconds : parseInt(seconds) || 0;
  const mins = Math.floor(secs / 60);
  const remainingSecs = secs % 60;
  console.log(`formatTime: 输入=${seconds}, 转换后=${secs}, 分钟=${mins}, 秒=${remainingSecs}`);
  return `${mins}:${remainingSecs.toString().padStart(2, '0')}`;
};

// 视频缩略图组件
const VideoThumbnail = ({ videoUrl, posterUrl, width, height, category }) => {
  
  console.log('VideoThumbnail - videoUrl:', videoUrl?.substring(0, 50), 'posterUrl:', posterUrl?.substring(0, 50));
  
  // 根据分类选择不同的默认缩略图
  const getCategoryImage = () => {
    const categoryImages = {
      universe: 'https://images.unsplash.com/photo-1509926168240-2a8a8a7c9b5f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      physics: 'https://images.unsplash.com/photo-1636163689822-8f5b46279e41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      chemistry: 'https://images.unsplash.com/photo-1586495777744-4413f21062fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      earth: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      biology: 'https://images.unsplash.com/photo-1589515873486-966e8b671011?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      plants: 'https://images.unsplash.com/photo-1487088678257-3a541e6e3922?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      animals: 'https://images.unsplash.com/photo-1504198266287-340e4d9fffb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      microbes: 'https://images.unsplash.com/photo-1598662538982-34939bbacd87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      ecology: 'https://images.unsplash.com/photo-1507525428034-b723cf961a36?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80',
      human: 'https://images.unsplash.com/photo-1581092794730-1207c7a1a308?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80'
    };
    return categoryImages[category] || 'https://images.unsplash.com/photo-1516110833967-8c716bf8273c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80';
  };

  if (posterUrl && posterUrl !== '') {
    console.log('Using poster image as thumbnail - full length:', posterUrl.length);
    const processedPosterUrl = getMediaUrl(posterUrl);
    return (
      <div style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: '#1a1a1a'
      }}>
        <img
          src={processedPosterUrl}
          onLoad={() => console.log('Poster image loaded successfully')}
          onError={(e) => {
            console.log('Poster image failed to load, showing fallback');
            e.target.style.display = 'none';
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0
          }}
          alt="视频封面"
        />
      </div>
    );
  }

  if (videoUrl && videoUrl !== '') {
    console.log('Using video as thumbnail');
    const processedVideoUrl = getMediaUrl(videoUrl);
    return (
      <div style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: '#333'
      }}>
        <video
          src={processedVideoUrl}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0
          }}
          muted
          playsInline
          preload="metadata"
          onLoadedMetadata={(e) => {
            console.log('Video loaded, setting time to 1s');
            try {
              e.target.currentTime = 1;
            } catch (err) {
              console.error('Error setting time:', err);
            }
          }}
          onError={(e) => {
            console.error('Video error:', e);
          }}
        />
      </div>
    );
  }

  console.log('Using category image as thumbnail');
  return (
    <div style={{
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden',
      backgroundImage: `url(${getCategoryImage()})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
    </div>
  );
};

const LearningStatistics = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    categories: [],
    subcategories: [],
    levels: [],
    durations: [],
    fileTypes: []
  });
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0
  });
  const [dropdownOpen, setDropdownOpen] = useState({
    level: false,
    duration: false,
    mainCategory: false,
    subcategory: false,
    fileType: false
  });
  const [learningStatus, setLearningStatus] = useState(new URLSearchParams(location.search).get('status') || 'all'); // all, learned, unlearned, collected
  const [selectedOptions, setSelectedOptions] = useState({
    levels: [],
    durations: [],
    categories: [],
    subcategories: [],
    fileTypes: []
  });
  const [collectedVideos, setCollectedVideos] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  useEffect(() => {
    fetchCourses();
  }, [filters, pagination.page, learningStatus]);

  // 点击页面其他地方关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 检查点击的元素是否在下拉菜单容器内
      const dropdownContainers = document.querySelectorAll('[style*="position: relative"]');
      let isClickInside = false;
      
      dropdownContainers.forEach(container => {
        if (container.contains(event.target)) {
          isClickInside = true;
        }
      });
      
      if (!isClickInside) {
        setDropdownOpen({
          level: false,
          duration: false,
          category: false,
          fileType: false
        });
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // 加载收藏的视频
  useEffect(() => {
    try {
      const collected = JSON.parse(localStorage.getItem('collectedVideos') || '[]');
      setCollectedVideos(collected);
    } catch (error) {
      console.error('Failed to load collected videos:', error);
      setCollectedVideos([]);
    }
  }, []);

  // 切换收藏状态
  const toggleCollect = (e, videoId) => {
    e.preventDefault();
    e.stopPropagation();
    
    const isCollected = collectedVideos.includes(videoId);
    let newCollected;
    
    if (isCollected) {
      newCollected = collectedVideos.filter(id => id !== videoId);
    } else {
      newCollected = [...collectedVideos, videoId];
    }
    
    setCollectedVideos(newCollected);
    localStorage.setItem('collectedVideos', JSON.stringify(newCollected));
  };

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const params = {
        category: filters.category,
        subcategory: filters.subcategory,
        levels: filters.levels.join(','),
        durations: filters.durations.join(','),
        page: pagination.page,
        limit: 12
      };
      Object.keys(params).forEach(key => !params[key] && delete params[key]);
      
      console.log('Fetching courses with params:', params);
      const res = await courseAPI.getCourses(params);
      console.log('Fetched courses:', res.data.courses);
      
      // 打印每个课程的duration
      if (res.data.courses && res.data.courses.length > 0) {
        console.log('课程时长详情:');
        res.data.courses.forEach((course, index) => {
          console.log(`课程${index + 1}: ${course.title}, duration: ${course.duration}, type: ${typeof course.duration}, formatTime: ${formatTime(course.duration || 0)}`);
        });
      }
      
      // 获取学习记录
      const learnedCourses = JSON.parse(localStorage.getItem('learnedCourses') || '[]');
      
      // 获取收藏的视频
      const collectedVideos = JSON.parse(localStorage.getItem('collectedVideos') || '[]');
      
      // 根据学习状态过滤视频
      let filteredCourses = res.data.courses || [];
      if (learningStatus === 'learned') {
        filteredCourses = filteredCourses.filter(course => {
          const courseId = course._id;
          const videoId = course._id.replace('uploaded_', '');
          return learnedCourses.includes(courseId) || learnedCourses.includes(videoId);
        });
      } else if (learningStatus === 'unlearned') {
        filteredCourses = filteredCourses.filter(course => {
          const courseId = course._id;
          const videoId = course._id.replace('uploaded_', '');
          return !learnedCourses.includes(courseId) && !learnedCourses.includes(videoId);
        });
      } else if (learningStatus === 'collected') {
        filteredCourses = filteredCourses.filter(course => {
          const courseId = course._id;
          const videoId = course._id.replace('uploaded_', '');
          return collectedVideos.includes(courseId) || collectedVideos.includes(videoId);
        });
      }
      
      // 根据分类过滤（支持多选）
      if (filters.categories && filters.categories.length > 0) {
        filteredCourses = filteredCourses.filter(course => filters.categories.includes(course.category));
      }
      
      // 根据子分类过滤（支持多选）
      if (filters.subcategories && filters.subcategories.length > 0) {
        filteredCourses = filteredCourses.filter(course => {
          return filters.subcategories.some(subcat => 
            course.subcategory === subcat || 
            course.title.toLowerCase().includes(subcat.toLowerCase())
          );
        });
      }
      
      // 根据难度级别过滤
      if (filters.levels && filters.levels.length > 0) {
        filteredCourses = filteredCourses.filter(course => filters.levels.includes(course.level));
      }
      
      // 根据时长过滤（duration单位是秒，需要转换为分钟）
      if (filters.durations && filters.durations.length > 0) {
        filteredCourses = filteredCourses.filter(course => {
          const durationInMinutes = (course.duration || 0) / 60;
          return filters.durations.some(durationType => {
            if (durationType === 'short') return durationInMinutes < 5;
            if (durationType === 'medium') return durationInMinutes >= 5 && durationInMinutes <= 10;
            if (durationType === 'long') return durationInMinutes > 10;
            return false;
          });
        });
      }
      
      // 根据文件类型过滤
      if (filters.fileTypes && filters.fileTypes.length > 0) {
        filteredCourses = filteredCourses.filter(course => {
          return filters.fileTypes.includes(course.fileType || 'video');
        });
      }
      
      setCourses(filteredCourses);
      setPagination({
        page: res.data.currentPage,
        totalPages: res.data.totalPages,
        total: filteredCourses.length
      });
    } catch (error) {
      console.error('Failed to fetch courses', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleDropdown = (type) => {
    setDropdownOpen(prev => {
      // 关闭所有其他下拉菜单，只切换当前的
      const newState = {
        level: false,
        duration: false,
        mainCategory: false,
        subcategory: false,
        fileType: false
      };
      return {
        ...newState,
        [type]: !prev[type]
      };
    });
  };

  const toggleOption = (type, value) => {
    setSelectedOptions(prev => {
      const newOptions = {
        ...prev,
        [type]: prev[type].includes(value)
          ? prev[type].filter(item => item !== value)
          : [...prev[type], value]
      };
      
      // Update filters
      setFilters(prevFilters => ({
        ...prevFilters,
        [type]: newOptions[type]
      }));
      
      // Reset pagination
      setPagination(prev => ({
        ...prev,
        page: 1
      }));
      
      return newOptions;
    });
  };

  const selectAll = (type, options) => {
    const allValues = options.map(opt => opt.value);
    setSelectedOptions(prev => ({
      ...prev,
      [type]: allValues
    }));
    
    // Update filters
    setFilters(prevFilters => ({
      ...prevFilters,
      [type]: allValues
    }));
    
    // Reset pagination
    setPagination(prev => ({
      ...prev,
      page: 1
    }));
  };

  const clearAll = (type) => {
    setSelectedOptions(prev => ({
      ...prev,
      [type]: []
    }));
    
    // Update filters
    setFilters(prevFilters => ({
      ...prevFilters,
      [type]: []
    }));
    
    // Reset pagination
    setPagination(prev => ({
      ...prev,
      page: 1
    }));
  };

  const levels = [
    { value: 'Starters', label: 'Starters' },
    { value: 'Movers', label: 'Movers' },
    { value: 'Flyers', label: 'Flyers' },
    { value: 'KET', label: 'KET' },
    { value: 'PET', label: 'PET' },
    { value: 'FCE', label: 'FCE' }
  ];

  const durations = [
    { value: 'short', label: '短 (<5分钟)' },
    { value: 'medium', label: '中 (5-10分钟)' },
    { value: 'long', label: '长 (>10分钟)' }
  ];

  const fileTypes = [
    { value: 'video', label: '视频' },
    { value: 'audio', label: '音频' }
  ];

  const categories = [
    { value: 'universe', label: '宇宙与空间科学' },
    { value: 'physics', label: '物理学' },
    { value: 'chemistry', label: '化学' },
    { value: 'earth', label: '地球科学' },
    { value: 'biology', label: '基础生物学' },
    { value: 'plants', label: '植物学' },
    { value: 'animals', label: '动物学' },
    { value: 'microbes', label: '微生物学' },
    { value: 'ecology', label: '生态学' },
    { value: 'human', label: '人体科学' }
  ];

  // 各分类的详细子分类
  const subcategories = {
    universe: [
      { value: 'stars_galaxies_blackholes', label: '恒星、星系与黑洞 - Stars, Galaxies & Black Holes' },
      { value: 'solar_system', label: '太阳系 - The Solar System' },
      { value: 'moon_space_exploration', label: '月球与太空探索 - The Moon & Space Exploration' },
      { value: 'astronomy_observation', label: '天文观测 - Astronomy & Sky Watching' }
    ],
    physics: [
      { value: 'forces_motion', label: '力与运动 - Forces & Motion' },
      { value: 'energy', label: '能量 - Energy（含热、电、简单电路）' },
      { value: 'sound_light', label: '声与光 - Sound & Light' },
      { value: 'magnetism', label: '磁 - Magnetism' }
    ],
    chemistry: [
      { value: 'states_properties', label: '物质的状态与性质 - States & Properties of Matter' },
      { value: 'mixtures_separation', label: '混合物与分离 - Mixtures & Separation' },
      { value: 'acids_bases_reactions', label: '酸碱与反应 - Acids, Bases & Reactions' },
      { value: 'elements_periodic_table', label: '元素与周期表 - Elements & The Periodic Table' },
      { value: 'everyday_chemistry', label: '生活中的化学 - Chemistry in Everyday Life' }
    ],
    earth: [
      { value: 'rocks_fossils_geology', label: '岩石、化石与地质 - Rocks, Fossils & Geology' },
      { value: 'water_cycle_oceans', label: '水循环与海洋 - Water Cycle & Oceans' },
      { value: 'weather_climate', label: '天气与气候 - Weather & Climate' },
      { value: 'maps_globes', label: '地图与地球仪 - Maps & Globes' },
      { value: 'soil_land', label: '土壤与陆地 - Soil & Land' }
    ],
    biology: [
      { value: 'cells_genetics', label: '细胞与遗传 - Cells & Genetics' },
      { value: 'life_processes', label: '生命过程 - Life Processes（生命周期、进化）' },
      { value: 'ecology', label: '生态关系 - Ecology（食物链、栖息地）' },
      { value: 'classification_adaptations', label: '生物分类与适应 - Classification & Adaptations' },
      { value: 'humans_conservation', label: '人类与自然保护 - Humans & Conservation' }
    ],
    plants: [
      { value: 'seeds_growth', label: '种子与生长 - Seeds & Growth' },
      { value: 'flowers_pollination', label: '花与授粉 - Flowers & Pollination' },
      { value: 'photosynthesis_nutrition', label: '光合作用与养分 - Photosynthesis & Nutrition' },
      { value: 'plant_defenses_carnivorous', label: '植物的防御与奇特植物 - Plant Defenses & Carnivorous Plants' },
      { value: 'fungi_useful_plants', label: '真菌与人类使用的植物 - Fungi & Useful Plants' }
    ],
    animals: [
      { value: 'animal_classification', label: '动物分类 - Animal Classification（哺乳动物、鸟类、爬行类、两栖类、鱼类、无脊椎动物）' },
      { value: 'insects_spiders', label: '昆虫与蜘蛛 - Insects & Spiders' },
      { value: 'ocean_animals', label: '海洋动物 - Ocean Animals' },
      { value: 'animal_behaviors_life_cycles', label: '动物行为与生命周期 - Animal Behaviors & Life Cycles' },
      { value: 'endangered_animals_conservation', label: '濒危动物保护 - Endangered Animals & Conservation' }
    ],
    microbes: [
      { value: 'types_of_microbes', label: '微生物的种类 - Types of Microbes（细菌、病毒、真菌、原生生物）' },
      { value: 'habitats_of_microbes', label: '微生物的栖息地 - Habitats of Microbes' },
      { value: 'helpful_harmful_microbes', label: '有益与有害微生物 - Helpful & Harmful Microbes' },
      { value: 'microbes_food', label: '微生物与食物 - Microbes & Food' },
      { value: 'microscopes_observation', label: '显微镜与观察 - Microscopes & Observation' }
    ],
    ecology: [
      { value: 'land_ecosystems', label: '陆地生态 - Land Ecosystems（森林、沙漠、草原、极地）' },
      { value: 'water_ecosystems', label: '水域生态 - Water Ecosystems（海洋、淡水）' },
      { value: 'urban_ecology', label: '城市生态 - Urban Ecology' },
      { value: 'conservation', label: '生态保护 - Conservation（回收、生物多样性、可持续发展）' },
      { value: 'ecological_processes', label: '生态过程 - Ecological Processes（食物网、人类影响）' }
    ],
    human: [
      { value: 'skeletal_muscular_system', label: '骨骼与肌肉系统 - Skeletal & Muscular System' },
      { value: 'circulatory_respiratory_system', label: '循环与呼吸系统 - Circulatory & Respiratory System' },
      { value: 'digestive_endocrine_system', label: '消化与内分泌 - Digestive & Endocrine System' },
      { value: 'senses_nervous_system', label: '感官与神经系统 - Senses & Nervous System' },
      { value: 'health_disease', label: '健康与疾病 - Health & Disease' }
    ]
  };

  const getCategoryIcon = (category) => {
    const icons = {
      universe: '🛰️',
      physics: '🌡️',
      chemistry: '🧪',
      earth: '🌍',
      biology: '🧬',
      plants: '🌻',
      animals: '🦓',
      microbes: '🔬',
      ecology: '🌳',
      human: '🫀'
    };
    return icons[category] || '🔍';
  };

  const getDurationLabel = (duration) => {
    if (duration < 5) return '短 (<5分钟)';
    if (duration < 10) return '中 (5-10分钟)';
    return '长 (>10分钟)';
  };

  const getLevelLabel = (level) => {
    const levelMap = {
      'Starters': 'Starters',
      'Movers': 'Movers',
      'Flyers': 'Flyers',
      'KET': 'KET',
      'PET': 'PET',
      'FCE': 'FCE'
    };
    return levelMap[level] || level || '未设置';
  };

  const getCategoryLabel = (category) => {
    const categoryMap = {
      universe: '宇宙与空间科学',
      physics: '物理学',
      chemistry: '化学',
      earth: '地球科学',
      biology: '基础生物学',
      plants: '植物学',
      animals: '动物学',
      microbes: '微生物学',
      ecology: '生态学',
      human: '人体科学'
    };
    return categoryMap[category] || '科学';
  };

  return (
    <div style={{ backgroundColor: '#f0f8ff', color: '#1a2b4c', minHeight: '100vh' }}>
      {/* 顶部导航栏 */}
      <nav style={{ 
        position: 'sticky', 
        top: 0, 
        left: 0,
        right: 0,
        zIndex: 1000, 
        backgroundColor: 'rgba(255, 255, 255, 0.95)', 
        backdropFilter: 'blur(10px)',
        height: '64px',
        minHeight: '64px',
        boxShadow: '0 4px 20px rgba(0, 102, 255, 0.1)',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid rgba(0, 102, 255, 0.1)'
      }}>
        <div className="container" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          margin: '0 auto',
          padding: '0 1.5rem',
          boxSizing: 'border-box'
        }}>
          {/* 左侧区域 - 汉堡菜单 + Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {/* 汉堡菜单按钮 - 仅在小屏幕显示 */}
            <button 
              className="hamburger-menu-button"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              style={{
                display: 'none',
                width: '44px',
                height: '44px',
                backgroundColor: 'rgba(0, 102, 255, 0.1)',
                border: '2px solid rgba(0, 102, 255, 0.2)',
                borderRadius: '12px',
                cursor: 'pointer',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                flexShrink: 0,
                color: '#0066ff',
                padding: 0
              }}
            >
              ☰
            </button>
          
            {/* Logo */}
            <Link to="/" style={{ 
              display: 'flex', 
              alignItems: 'flex-end',
              textDecoration: 'none',
              color: '#1a2b4c'
            }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'nowrap' }}>
              <span style={{ 
                fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', 
                fontWeight: '700', 
                color: '#0066ff',
                letterSpacing: '-0.5px',
                lineHeight: '1'
              }}>123</span>
              <span style={{ 
                fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', 
                fontWeight: '700', 
                color: '#0066ff',
                letterSpacing: '-0.5px',
                lineHeight: '1'
              }}>wonder</span>
              <span style={{ 
                fontSize: 'clamp(0.9rem, 1.8vw, 1.4rem)', 
                fontWeight: '600', 
                color: '#1a2b4c',
                letterSpacing: '0.5px',
                lineHeight: '1',
                marginLeft: '0.5rem',
                transform: 'translateY(-4px)',
                whiteSpace: 'nowrap'
              }}>
                我的学习
              </span>
            </div>
          </Link>
          </div>
        </div>
      </nav>

      <div style={{ padding: '1.5rem 0', backgroundColor: '#f0f8ff' }}>
        <div className="container" style={{
          maxWidth: '1600px',
          margin: '0 auto',
          padding: '0 1.5rem'
        }}>


          {/* 遮罩层 - 点击关闭侧边栏 */}
          <div 
            className={`sidebar-overlay ${sidebarOpen ? 'sidebar-open' : ''}`}
            onClick={() => setSidebarOpen(false)}
            style={{
              display: 'none',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 99999,
              pointerEvents: 'auto'
            }}
          ></div>

          {/* 移动端侧边栏 - 小屏幕显示，大屏幕隐藏 */}
          <div 
            className={`courses-sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}
            style={{
              display: 'none',
              width: '300px',
              flexDirection: 'column',
              gap: '1rem',
              flexShrink: 0,
              justifyContent: 'flex-start',
              position: 'relative',
              zIndex: 100000,
              pointerEvents: 'auto'
            }}>

            {/* 文件类型 */}
            <div style={{
              width: '100%',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>🎬</span> 文件类型
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('fileType')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <span>{selectedOptions.fileTypes.length > 0 ? `${selectedOptions.fileTypes.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.fileType ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.fileType && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('fileTypes', fileTypes);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('fileTypes');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {fileTypes.map(fileType => (
                        <div key={fileType.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('fileTypes', fileType.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.fileTypes.includes(fileType.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('fileTypes', fileType.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{fileType.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 难度 */}
            <div style={{
              width: '100%',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>🎯</span> 难度
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('level')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <span>{selectedOptions.levels.length > 0 ? `${selectedOptions.levels.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.level ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.level && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('levels', levels);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('levels');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {levels.map(level => (
                        <div key={level.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('levels', level.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.levels.includes(level.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('levels', level.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{level.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 时长 */}
            <div style={{
              width: '100%',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>⏰</span> 时长
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('duration')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <span>{selectedOptions.durations.length > 0 ? `${selectedOptions.durations.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.duration ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.duration && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('durations', durations);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('durations');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {durations.map(duration => (
                        <div key={duration.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('durations', duration.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.durations.includes(duration.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('durations', duration.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{duration.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 分类 */}
            <div style={{
              width: '100%',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>📂</span> 分类
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('mainCategory')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <span>{selectedOptions.categories.length > 0 ? `${selectedOptions.categories.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.mainCategory ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.mainCategory && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('categories', categories);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('categories');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {categories.map(category => (
                        <div key={category.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.5rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('categories', category.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.categories.includes(category.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('categories', category.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c', fontSize: '0.9rem' }}>{category.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 子分类 */}
            <div style={{
              width: '100%',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>📁</span> 子分类
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('subcategory')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <span>{selectedOptions.subcategories.length > 0 ? `${selectedOptions.subcategories.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.subcategory ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.subcategory && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            let allSubcategories = [];
                            selectedOptions.categories.forEach(cat => {
                              allSubcategories = [...allSubcategories, ...(subcategories[cat] || [])];
                            });
                            if (selectedOptions.categories.length === 0) {
                              Object.keys(subcategories).forEach(cat => {
                                allSubcategories = [...allSubcategories, ...(subcategories[cat] || [])];
                              });
                            }
                            selectAll('subcategories', allSubcategories);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('subcategories');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {/* 根据当前分类显示对应的详细子分类 */}
                      {(selectedOptions.categories.length > 0 
                        ? selectedOptions.categories.flatMap(cat => (subcategories[cat] || []).map(subcat => ({ ...subcat, category: cat })))
                        : Object.keys(subcategories).flatMap(cat => (subcategories[cat] || []).map(subcat => ({ ...subcat, category: cat })))
                      ).map(subcat => (
                        <div key={subcat.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.5rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('subcategories', subcat.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.subcategories.includes(subcat.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('subcategories', subcat.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c', fontSize: '0.9rem' }}>{subcat.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* 侧边栏底部操作区 */}
            <div style={{
              marginTop: '0.5rem',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '12px',
              padding: '1rem',
              border: '1px solid rgba(0, 0, 0, 0.1)',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              {/* 显示已选择的筛选数量 */}
              {(() => {
                const selectedCount = selectedOptions.levels.length + 
                                    selectedOptions.durations.length + 
                                    selectedOptions.fileTypes.length +
                                    selectedOptions.categories.length +
                                    selectedOptions.subcategories.length +
                                    (learningStatus !== 'all' ? 1 : 0);
                return selectedCount > 0 ? (
                  <div style={{
                    textAlign: 'center',
                    fontSize: '0.85rem',
                    color: 'rgba(26, 43, 76, 0.7)'
                  }}>
                    已选择 <span style={{ fontWeight: '600', color: '#0066ff' }}>{selectedCount}</span> 个筛选条件
                  </div>
                ) : null;
              })()}
              
              {/* 操作按钮组 */}
              <div style={{
                display: 'flex',
                gap: '0.5rem'
              }}>
                {/* 清除所有筛选按钮 */}
                <button
                  onClick={() => {
                    setSelectedOptions({ levels: [], durations: [], categories: [], subcategories: [], fileTypes: [] });
                    setFilters({ categories: [], subcategories: [], levels: [], durations: [], fileTypes: [] });
                    setLearningStatus('all');
                    setPagination({ ...pagination, page: 1 });
                  }}
                  style={{
                    flex: 1,
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e0e0e0',
                    color: '#666',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e9ecef';
                    e.target.style.borderColor = '#ced4da';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                    e.target.style.borderColor = '#e0e0e0';
                  }}
                >
                  清除全部
                </button>
                
                {/* 完成/查看结果按钮 */}
                <button
                  onClick={() => setSidebarOpen(false)}
                  style={{
                    flex: 1.5,
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    background: 'linear-gradient(45deg, #0066ff, #6610f2)',
                    border: 'none',
                    color: 'white',
                    fontSize: '0.95rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 8px rgba(0, 102, 255, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0, 102, 255, 0.3)';
                  }}
                >
                  查看结果
                </button>
              </div>
            </div>
          </div>

          {/* 桌面端过滤导航栏 */}
          <div className="desktop-filters" style={{
            display: 'flex',
            gap: '1rem',
            marginBottom: '3rem',
            flexWrap: 'nowrap'
          }}>
            {/* 文件类型 */}
            <div style={{
              flex: 1,
              minWidth: '200px',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>🎬</span> 文件类型
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('fileType')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.1)';
                    e.target.style.borderColor = 'rgba(0, 102, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.05)';
                    e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <span>{selectedOptions.fileTypes.length > 0 ? `${selectedOptions.fileTypes.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.fileType ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.fileType && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('fileTypes', fileTypes);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('fileTypes');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {fileTypes.map(fileType => (
                        <div key={fileType.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('fileTypes', fileType.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.fileTypes.includes(fileType.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('fileTypes', fileType.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{fileType.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 难度 */}
            <div style={{
              flex: 1,
              minWidth: '200px',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>🎯</span> 难度
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('level')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.1)';
                    e.target.style.borderColor = 'rgba(0, 102, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.05)';
                    e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <span>{selectedOptions.levels.length > 0 ? `${selectedOptions.levels.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.level ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.level && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('levels', levels);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('levels');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {levels.map(level => (
                        <div key={level.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('levels', level.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.levels.includes(level.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('levels', level.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{level.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 时长 */}
            <div style={{
              flex: 1,
              minWidth: '200px',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>⏰</span> 时长
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('duration')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.1)';
                    e.target.style.borderColor = 'rgba(0, 102, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.05)';
                    e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <span>{selectedOptions.durations.length > 0 ? `${selectedOptions.durations.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.duration ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.duration && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('durations', durations);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('durations');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {durations.map(duration => (
                        <div key={duration.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.75rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('durations', duration.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.durations.includes(duration.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('durations', duration.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c' }}>{duration.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 分类 */}
            <div style={{
              flex: 1,
              minWidth: '200px',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>📂</span> 分类
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('mainCategory')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.1)';
                    e.target.style.borderColor = 'rgba(0, 102, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.05)';
                    e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <span>{selectedOptions.categories.length > 0 ? `${selectedOptions.categories.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.mainCategory ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.mainCategory && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            selectAll('categories', categories);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('categories');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {categories.map(category => (
                        <div key={category.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.5rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('categories', category.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.categories.includes(category.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('categories', category.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c', fontSize: '0.9rem' }}>{category.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 子分类 */}
            <div style={{
              flex: 1,
              minWidth: '200px',
              position: 'relative'
            }}>
              <label style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '0.5rem',
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: 'rgba(26, 43, 76, 0.8)'
              }}>
                <span style={{ fontSize: '1.2rem' }}>📁</span> 子分类
              </label>
              <div style={{
                position: 'relative'
              }}>
                <button
                  onClick={() => toggleDropdown('subcategory')}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    color: '#1a2b4c',
                    fontSize: '1rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 102, 255, 0.1)';
                    e.target.style.borderColor = 'rgba(0, 102, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
                    e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.05)';
                    e.target.style.borderColor = 'rgba(0, 0, 0, 0.1)';
                  }}
                >
                  <span>{selectedOptions.subcategories.length > 0 ? `${selectedOptions.subcategories.length} 个已选择` : '全部'}</span>
                  {dropdownOpen.subcategory ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                {dropdownOpen.subcategory && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    marginTop: '0.5rem',
                    zIndex: 1000,
                    maxHeight: '300px',
                    overflowY: 'auto',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                  }}>
                    <div style={{
                      padding: '1rem',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    >
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            let allSubcategories = [];
                            selectedOptions.categories.forEach(cat => {
                              allSubcategories = [...allSubcategories, ...(subcategories[cat] || [])];
                            });
                            if (selectedOptions.categories.length === 0) {
                              Object.keys(subcategories).forEach(cat => {
                                allSubcategories = [...allSubcategories, ...(subcategories[cat] || [])];
                              });
                            }
                            selectAll('subcategories', allSubcategories);
                          }}
                        >全选</span>
                        <span 
                          style={{ color: '#1a2b4c', fontWeight: '600', cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            clearAll('subcategories');
                          }}
                        >清空</span>
                      </div>
                    </div>
                    <div style={{
                      padding: '1rem'
                    }}>
                      {/* 根据当前分类显示对应的详细子分类 */}
                      {(selectedOptions.categories.length > 0 
                        ? selectedOptions.categories.flatMap(cat => (subcategories[cat] || []).map(subcat => ({ ...subcat, category: cat })))
                        : Object.keys(subcategories).flatMap(cat => (subcategories[cat] || []).map(subcat => ({ ...subcat, category: cat })))
                      ).map(subcat => (
                        <div key={subcat.value} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          marginBottom: '0.5rem',
                          cursor: 'pointer',
                          padding: '0.25rem 0',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => toggleOption('subcategories', subcat.value)}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(0, 102, 255, 0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions.subcategories.includes(subcat.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption('subcategories', subcat.value);
                            }}
                            onChange={(e) => {
                              e.stopPropagation();
                            }}
                            style={{
                              width: '16px',
                              height: '16px',
                              accentColor: '#0066ff',
                              pointerEvents: 'auto'
                            }}
                          />
                          <span style={{ color: '#1a2b4c', fontSize: '0.9rem' }}>{subcat.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 视频展示区 */}
          {loading ? (
            <div className="video-grid" style={{ 
              display: 'grid', 
              gap: '2rem',
              marginBottom: '4rem'
            }}>
              {Array(6).fill(0).map((_, index) => (
                <div key={index} style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '1.5rem',
                  border: '1px solid #e0e0e0',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)'
                }}>
                  <div style={{
                    width: '100%',
                    height: '180px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px',
                    marginBottom: '1rem'
                  }}></div>
                  <div style={{
                    width: '80%',
                    height: '20px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginBottom: '0.5rem'
                  }}></div>
                  <div style={{
                    width: '60%',
                    height: '16px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px'
                  }}></div>
                </div>
              ))}
            </div>
          ) : courses.length > 0 ? (
            <>
              <div className="video-grid" style={{
                display: 'grid',
                gap: '1.5rem',
                marginBottom: '4rem'
              }}>
                {courses.map((course) => (
                  <Link 
                    to={`/lesson/${course._id}/${course.lessons && course.lessons.length > 0 ? course.lessons[0]._id : '101'}`} 
                    key={course._id} 
                    style={{
                      textDecoration: 'none',
                      backgroundColor: '#ffffff',
                      borderRadius: '24px',
                      overflow: 'hidden',
                      border: '2px solid rgba(0, 102, 255, 0.2)',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 8px 24px rgba(0, 102, 255, 0.12)',
                      display: 'flex',
                      flexDirection: 'column'
                    }} 
                    onClick={(e) => {
                      console.log('Video clicked, navigating to:', `/lesson/${course._id}/${course.lessons && course.lessons.length > 0 ? course.lessons[0]._id : '101'}`);
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 16px 32px rgba(0, 102, 255, 0.2)';
                      e.currentTarget.style.borderColor = 'rgba(0, 102, 255, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 102, 255, 0.12)';
                      e.currentTarget.style.borderColor = 'rgba(0, 102, 255, 0.2)';
                    }}
                  >
                    <div style={{
                      position: 'relative',
                      width: '100%',
                      paddingBottom: '56.25%', // 16:9比例
                      overflow: 'hidden'
                    }}>
                      {/* 视频首帧图 */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        {(() => {
                          const extractedVideoUrl = course.lessons && course.lessons[0]?.content?.videoUrl ? course.lessons[0].content.videoUrl : '';
                          const extractedPosterUrl = course.thumbnail || (course.lessons && course.lessons[0]?.content?.posterUrl ? course.lessons[0].content.posterUrl : '');
                          console.log('=== 课程数据详情 ===');
                          console.log('完整 course 对象:', course);
                          console.log('course.thumbnail:', course.thumbnail);
                          console.log('course.lessons[0].content.posterUrl:', course.lessons && course.lessons[0]?.content?.posterUrl);
                          console.log('最终 extractedPosterUrl:', extractedPosterUrl);
                          console.log('Course videoUrl:', extractedVideoUrl);
                          return (
                            <VideoThumbnail 
                              videoUrl={extractedVideoUrl} 
                              posterUrl={extractedPosterUrl}
                              width={320} 
                              height={180} 
                              category={course.category}
                            />
                          );
                        })()}
                      </div>
                      {/* 收藏按钮 */}
                      <button
                        onClick={(e) => toggleCollect(e, course._id)}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          right: '8px',
                          backgroundColor: 'transparent',
                          border: 'none',
                          borderRadius: '50%',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          zIndex: 10
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'scale(1)';
                        }}
                      >
                        <FiHeart 
                          size={20} 
                          color={collectedVideos.includes(course._id) ? '#ff4757' : '#ff4757'}
                          fill={collectedVideos.includes(course._id) ? '#ff4757' : 'none'}
                        />
                      </button>

                    </div>
                    <div style={{ padding: '1.25rem' }}>
                      {/* 视频标题 */}
                      <h3 style={{
                        color: '#000000',
                        fontSize: '1.15rem',
                        fontWeight: '800',
                        margin: '0 0 1rem 0',
                        lineHeight: '1.4',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {course.title}
                      </h3>
                      
                      {/* 分类、难易度、时长、上传日期 */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                          <span style={{
                            backgroundColor: 'rgba(0, 102, 255, 0.1)',
                            color: '#0066ff',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '11px',
                            fontWeight: '700',
                            border: '1px solid rgba(0, 102, 255, 0.2)'
                          }}>
                            {getCategoryLabel(course.category)}
                          </span>
                          <span style={{
                            backgroundColor: 'rgba(134, 239, 172, 0.3)',
                            color: '#15803d',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '11px',
                            fontWeight: '700',
                            border: '1px solid rgba(134, 239, 172, 0.4)'
                          }}>
                            {getLevelLabel(course.level)}
                          </span>
                          <span style={{
                            backgroundColor: 'rgba(251, 191, 36, 0.2)',
                            color: '#b45309',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '11px',
                            fontWeight: '700',
                            border: '1px solid rgba(251, 191, 36, 0.3)'
                          }}>
                            {formatTime(course.duration)}
                          </span>
                          <span style={{
                            backgroundColor: 'rgba(192, 132, 252, 0.2)',
                            color: '#7c3aed',
                            padding: '4px 12px',
                            borderRadius: '16px',
                            fontSize: '11px',
                            fontWeight: '700',
                            border: '1px solid rgba(192, 132, 252, 0.3)'
                          }}>
                            {course.fileType === 'audio' ? '🎵 音频' : '🎬 视频'}
                          </span>
                        </div>
                        <span style={{ fontSize: '11px', color: '#666666', fontWeight: '600' }}>
                          {new Date(course.createdAt || Date.now()).toLocaleDateString()}
                        </span>
                      </div>
                      

                      

                    </div>
                  </Link>
                ))}
              </div>

              {/* 分页 */}
              {pagination.totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '40px' }}>
                  <button
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '2px solid rgba(0, 102, 255, 0.2)',
                      color: '#0066ff',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '16px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      fontWeight: '600',
                      fontSize: '0.95rem'
                    }}
                    onClick={() => setPagination({ ...pagination, page: pagination.page - 1 })}
                    disabled={pagination.page === 1}
                  >
                    ← 上一页
                  </button>
                  <span style={{ display: 'flex', alignItems: 'center', padding: '0 24px', color: '#1a2b4c', fontWeight: '600', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '16px', border: '2px solid rgba(0, 102, 255, 0.1)' }}>
                    第 {pagination.page} 页，共 {pagination.totalPages} 页
                  </span>
                  <button
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '2px solid rgba(0, 102, 255, 0.2)',
                      color: '#0066ff',
                      padding: '0.75rem 1.5rem',
                      borderRadius: '16px',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      fontWeight: '600',
                      fontSize: '0.95rem'
                    }}
                    onClick={() => setPagination({ ...pagination, page: pagination.page + 1 })}
                    disabled={pagination.page === pagination.totalPages}
                  >
                    下一页 →
                  </button>
                </div>
              )}
            </>
          ) : (
            <div style={{
              textAlign: 'center',
              padding: '4rem',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              borderRadius: '24px',
              border: '2px solid rgba(0, 102, 255, 0.1)'
            }}>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔍</div>
              <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem', color: '#1a2b4c' }}>暂无视频</h3>
              <p style={{ color: 'rgba(26, 43, 76, 0.7)' }}>我们正在准备更多精彩的科学视频，请稍后再来查看</p>
            </div>
          )}
        </div>
      </div>

      {/* 响应式样式 */}
      <style>{`
        /* 视频网格 - 桌面端 3列 */
        .video-grid {
          grid-template-columns: repeat(3, 1fr);
        }
        
        /* 平板和手机 - 显示汉堡菜单，隐藏桌面端筛选和头部按钮，显示侧边栏，2列 */
        @media (max-width: 1024px) {
          .hamburger-menu-button {
            display: flex !important;
          }
          
          .desktop-filters {
            display: none !important;
          }
          
          .desktop-header-buttons {
            display: none !important;
          }
          
          .courses-sidebar {
            display: none !important;
            position: fixed !important;
            left: 0;
            top: 70px;
            z-index: 999 !important;
            background-color: #f8f9fa;
            padding: 1rem;
            height: calc(100vh - 70px);
            overflow-y: auto;
            box-shadow: 4px 0 10px rgba(0,0,0,0.1);
            justify-content: flex-start !important;
            align-content: flex-start !important;
            pointer-events: auto !important;
          }
          
          .courses-sidebar.sidebar-open {
            display: flex !important;
          }
          
          .sidebar-overlay.sidebar-open {
            display: block !important;
            z-index: 998 !important;
            pointer-events: auto !important;
          }
          
          /* 视频网格 - 平板/手机横屏 2列 */
          .video-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        /* 手机竖屏 - 1列 */
        @media (max-width: 600px) {
          .video-grid {
            grid-template-columns: 1fr;
          }
        }
        
        /* 侧边栏遮罩层 */
        .sidebar-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.3);
          z-index: 99999;
          pointer-events: auto;
        }
        
        @media (max-width: 1024px) {
          .sidebar-overlay.sidebar-open {
            display: block;
          }
          
          .desktop-filters {
            flex-wrap: nowrap !important;
          }
        }
        
        @media (max-width: 600px) {
          .desktop-filters {
            flex-wrap: wrap !important;
          }
        }
      `}</style>

    </div>
  );
};

export default LearningStatistics;
